// extracted by mini-css-extract-plugin
module.exports = {"search-section":"search-section_search-section__3L6eJ"};